<template>
    <div class="mywxdetail">
        <h3>普惠个贷：PHGD202188883399
        </h3>
        <el-row class="idata">
            <el-col :span="8"><span class="color_red">10万</span>金额</el-col>
            <el-col :span="8"><span>9.8%</span>利率</el-col>
            <el-col :span="8"><span>180天</span>期限</el-col>
        </el-row>
        <el-row class="desc">
            <el-col :span="24">
                起投额度：100元 <br />
                担保机构：某某担保公司      <br />
                还款方式：到期还本付息 <br />
                贷款用途：合法合规，具体不要求 <br />
                保证方式：第三方担保 <br />
                贷款主体：中国公民，持有二代身份证   <br />
                发布日期：2018-05-04  10:30:28    <br />
                截止日期：2018-11-04 10:30:28
            </el-col>
        </el-row>
        <div class="db_desc_more">
            <template>
                <el-tabs type="border-card" value="first" @tab-click="handleClick" stretch>
                    <el-tab-pane label="项目简介" name="first">
                        <div class="tab_con">
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="项目资料" name="second">
                        <div class="tab_con">
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="投资记录" name="third">
                        <div class="tab_con">
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                            <p>公司依照国际规范进行市场运作，为企业及个人提供经济与技术性投资、联合投资管理、资本融通、基金管理、资产管理、国际成熟技术转让与投资、上市策划等专业服务。现受国内国外多家投资机构委托，现有大量资金在国内寻找好的项目进行投资与借贷。如果贵公司或贵方需要资金，只要项目真实、合法、有效、有利可图，可以与我们取得联系，我们将尽快为您运作。</p>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </template>
        </div>

        <div class="btns_bottom">
            <a class="btn_b">约谈项目</a>
        </div>

    </div>
</template>
<script>
    export default {
        data(){
          return{

          }
        },
        methods:{
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();
        }
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxMyBorrowProjectDetail.vue